<template>
  <Transition
    :css="false"
    @enter="scrollAnimation"
  >
    <main class="all-projects scf-main-margins scf-row">
      <div class="scf-row__inner" v-if="highlightProjects.length">
        <header class="content-header scf-margin-bottom--xl">
          <h2
            class="content-header__menu-title scf-heading-s scf-margin-bottom--xl"
          >
            Highlights
          </h2>
        </header>

        <div class="all-projects__content all-projects__content--highlights">
          <section
            v-for="(project, index) in highlightProjects"
            :key="project.id"
            class="card"
            :class="index % 2 == 0 ? 'even' : 'odd'"
            @click="
              $store.state.detailProject = project.id;
              $store.state.targetComponent = 'detailProject';
            "
            @mouseover="hovered = index"
            @mouseleave="hovered = null"
          >
            <div class="section-content">
              <div class="section-content--inner">
                <h3 class="section-title scf-heading-s scf-margin-bottom--xs">
                  {{ project.title }}
                </h3>
                <p
                  class="section-text scf-body-m"
                  v-html="project.introduction"
                ></p>
              </div>
            </div>
            <picture>
              <img
                :src="
                  hovered == index
                    ? './images/projects/' + project.animGif[0].gif
                    : './images/projects/' + project.animGif[0].static
                "
                :alt="project.title"
              />
            </picture>
          </section>
        </div>
      </div>

      <div class="scf-row__inner">
        <header class="content-header scf-margin-bottom--xl">
          <h2
            class="content-header__menu-title scf-heading-s scf-margin-bottom--xl"
          >
            All Projects
          </h2>
        </header>

        <div class="all-projects__content">
          <section
            v-for="(project, index) in projects"
            :key="project.id"
            class="card"
            :class="index % 2 == 0 ? 'even' : 'odd'"
            @click="
              $store.state.detailProject = project.id;
              $store.state.targetComponent = 'detailProject';
            "
            @mouseover="hovered = index"
            @mouseleave="hovered = null"
          >
            <div class="section-content">
              <div class="section-content--inner">
                <h3 class="section-title scf-heading-s scf-margin-bottom--xs">
                  {{ project.title }}
                </h3>
                <p
                  class="section-text scf-body-m"
                  v-html="project.introduction"
                ></p>
              </div>
            </div>
            <picture>
              <img
                :src="
                  hovered == index
                    ? './images/projects/' + project.animGif[0].gif
                    : './images/projects/' + project.animGif[0].static
                "
                :alt="project.title"
              />
            </picture>
          </section>
        </div>
      </div>
    </main>
  </Transition>
</template>

<script>
export default {
  name: "AllProjects",
  props: {
    projects: {
      type: Array,
      required: true,
    },
    highlightProjects: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      hovered: null,
    };
  },
  mounted: function () {
    this.scrollAnimation();
  },
  methods: {
    scrollAnimation() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../styles/all.less";

.all-projects {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.all-projects__content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 20px;

  &--highlights {
    margin-bottom: 60px;
  }

  .card {
    cursor: pointer;
    width: 100%;
    border: 1px solid @white-20;
    background-color: transparent;
    transition: background-color 2s ease;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    border-radius: @scf-border-radius;
    overflow: hidden;

    @media @scf-breakpoints--s {
      width: calc(50% - 17px);
    }

    @media @scf-breakpoints--m {
      width: calc(33.3333% - 17px);
    }

    @media @scf-breakpoints--l {
      width: calc(25% - 17px);
    }

    picture {
      position: relative;
      border-bottom: 1px solid @white-20;
      flex: 2;
      min-width: 50%;

      img {
        height: 400px;
        width: 100%;
        display: block;
        object-fit: cover;
        object-position: center center;
        @supports (mix-blend-mode: luminosity) {
          mix-blend-mode: luminosity;
        }
        @supports not (mix-blend-mode: luminosity) {
          opacity: 1;
        }
      }
    }

    .section-text {
      display: -webkit-box;
      line-clamp: 4;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      opacity: 0;
      max-height: 0;
      transition: opacity 2s, max-height 1s;
    }

    &:hover {
      border-color: @white;
      background-color: @base-dark;
      transition: background-color 2s ease;

      picture {
        border-bottom: 1px solid @white;
      }

      picture {
        img {
          @supports (mix-blend-mode: luminosity) {
            mix-blend-mode: normal;
          }
          @supports not (mix-blend-mode: luminosity) {
            opacity: 0.5;
          }
          //maybe its this idk...
          //content: url("'./images/projects/' + project.images[0]");
        }
      }

      .section-title {
        color: @accent;
      }
      .section-text {
        opacity: 1;
        max-height: 120px;
        transition: opacity 2s, max-height 1s;
      }
    }
  }

  .section-content {
    padding: @scf-space-l;
    flex-grow: 1;
  }
}
</style>
